import React, {useEffect, useState} from 'react';
import {BooleanInput, LargeTextInput, Option, Section, SelectInput, TextInput} from "../../../components/PropertyEditor";
import Icon from "../../../components/Icon";
import Button from "../../../components/Buttons/Button";
import DisplayEvent from "./DisplayEventAsCode";
import FacebookEventModal from "./FacebookEventModal";
import FacebookEventForm from "./FacebookEventForm";
import PropTypes from 'prop-types';
import {ProjectFacebookPixel} from "./ProjectFacebookPixel";

const _props = {
  // The label used on the toggle
  label: PropTypes.string,
  // Should return a promise so we can manage the loading state
  onChangeShouldSendEvent: PropTypes.func.isRequired,
  // Should return a promise for managing loading state
  onChangeEventId: PropTypes.func.isRequired,
  // Bool that controls the true false value of the toggle
  shouldSendEvent: PropTypes.number.isRequired,
  // The event ID, if none exists the component will create one
  eventId: PropTypes.number.isRequired,
};

const FacebookEventToggle = ({update, eventId}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  
	const  onChangeEventId = async (val) => {
		setLoading(true);
		await update('actionArg', val.toString());
		setLoading(false);
	}

  return(
    <>
		<ProjectFacebookPixel />
      {/* Show when the component is updating the interaction */}
      {!!loading && <Icon loading />}

      {/* Displays the event as read only html with some syntax highlighting */}
      {!loading && !! eventId && <>
        <label className={'mt-0'}>Preview</label>
        <DisplayEvent eventId={eventId} />
      </>}

      <div style={{marginBottom: '30px'}} className={'clearfix'}>
        {/* Show the create button, the modal is opened automatically but if they close that we still have a button to reopen it */}
        {!loading && ! eventId && <Button small onClick={()=>setShowModal(true)} icon={'plus'}>Create Event</Button>}

        {/* If we have an event ID we show an edit button instead of the create button */}
        {!loading && !! eventId && <Button small onClick={()=>setShowModal(true)} icon={'edit'}>Edit Event</Button>}
      </div>

      {/* The edit / create button opens this modal to create/edit the event */}
      <FacebookEventModal
        toggleModal={setShowModal}
        showModal={showModal}
      >
        <FacebookEventForm eventId={eventId} onChangeEventId={onChangeEventId}  toggleModal={setShowModal} />
      </FacebookEventModal>
    </>
  );
};
FacebookEventToggle.prototype = _props;
export default FacebookEventToggle;
